module.exports = __webpack_public_path__ + "media/images/cleaning/pro2@2x-4e6d43c1088b28d45c915154ff712d1b.jpg";